import React, { useState } from "react";
import {
  Receipt as ReceiptIcon,
  CheckCircleFill as CheckCircleIcon,
  Gear as GearIcon,
  ClockHistory as HistoryIcon,
} from "react-bootstrap-icons";
import TransactionLimit from "./TransactionLimit";
import PaymentLimit from "./PaymentLimit";
import TransactionHistory from "./TransactionHistory";
import Settings from "./Settings";
import PaymentLimitGroup from "./PaymentLimitGroup";
import KYC from "./KYC";
import AddMoneyModal from "../AddMoney/AddMoneyModal";

const CardManagement = ({
  cardBalance,
  cardDetails,
  fetchCardDetails,
  fetchCardBalance,
}) => {
  const [activeTab, setActiveTab] = useState("limit");
  const [tabClickKey, setTabClickKey] = useState(0);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setTabClickKey((prev) => prev + 1); // Triggers re-render of the selected tab content
  };

  const [showModal, setShowModal] = useState(false);

  return (
    <div className="">
      <div className="row justify-content-center">
        <div className="col-md-12 col-lg-12">
          {/* Balance Card */}
          <div className="card mb-4">
            <div className="card-body">
              <div className="row align-items-center text-center">
                <div className="col-md-4 mb-3 mb-md-0">
                  <h6 className="mb-1">Card Balance</h6>
                  <h4 className="text-success">
                    ₹{cardBalance ? cardBalance.available_balance : "-"}
                  </h4>
                </div>
                <div className="col-md-4 mb-3 mb-md-0">
                  <h6 className="mb-1">Monthly Reloadable Limit</h6>
                  <h5>
                    ₹{cardBalance ? cardBalance.monthly_reloadable_amount : "-"}
                  </h5>
                </div>
                <div className="col-md-4">
                  <button
                    className="btn btn-success"
                    onClick={() => setShowModal(true)}
                  >
                    Add Money
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Tabs */}
          <div className="card">
            <div className="card-body p-0">
              <ul
                className="nav nav-tabs w-100"
                role="tablist"
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  flexDirection: window.innerWidth <= 768 ? "column" : "row",
                }}
              >
                {[
                  {
                    key: "limit",
                    icon: <ReceiptIcon className="me-1" />,
                    label: "Transaction Limit",
                  },
                  {
                    key: "payment",
                    icon: <ReceiptIcon className="me-1" />,
                    label: "Payment Limit",
                  },
                  {
                    key: "kyc",
                    icon: <CheckCircleIcon className="text-success me-1" />,
                    label: "KYC Details",
                  },
                  {
                    key: "settings",
                    icon: <GearIcon className="me-1" />,
                    label: "Settings",
                  },
                  {
                    key: "history",
                    icon: <HistoryIcon className="me-1" />,
                    label: "Transaction History",
                  },
                ].map(({ key, icon, label }) => (
                  <li
                    className="nav-item"
                    role="presentation"
                    key={key}
                    style={{
                      width: window.innerWidth <= 768 ? "100%" : "auto",
                    }}
                  >
                    <button
                      className={`nav-link w-100 text-center ${
                        activeTab === key ? "active" : ""
                      }`}
                      onClick={() => handleTabChange(key)}
                      style={{
                        padding: "10px 12px",
                        fontSize: "14px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <span style={{ fontSize: "20px" }}>{icon}</span>
                        <span style={{ fontSize: "14px", fontWeight: 500 }}>
                          {label}
                        </span>
                      </div>
                    </button>
                  </li>
                ))}
              </ul>

              <div className="tab-content p-2">
                <div
                  className={`tab-pane fade ${
                    activeTab === "limit" ? "show active" : ""
                  }`}
                >
                  {activeTab === "limit" && (
                    <TransactionLimit
                      key={tabClickKey}
                      cardDetails={cardDetails}
                      fetchCardDetails={fetchCardDetails}
                    />
                  )}
                </div>

                <div
                  className={`tab-pane fade ${
                    activeTab === "payment" ? "show active" : ""
                  }`}
                >
                  {activeTab === "payment" && (
                    <PaymentLimitGroup key={tabClickKey} />
                  )}
                </div>

                <div
                  className={`tab-pane fade ${
                    activeTab === "kyc" ? "show active" : ""
                  }`}
                >
                  {activeTab === "kyc" && (
                    <KYC
                      key={tabClickKey}
                      cardDetails={cardDetails}
                      fetchCardDetails={fetchCardDetails}
                    />
                  )}
                </div>

                <div
                  className={`tab-pane fade ${
                    activeTab === "settings" ? "show active" : ""
                  }`}
                >
                  {activeTab === "settings" && (
                    <Settings
                      key={tabClickKey}
                      cardDetails={cardDetails}
                      fetchCardDetails={fetchCardDetails}
                    />
                  )}
                </div>

                <div
                  className={`tab-pane fade ${
                    activeTab === "history" ? "show active" : ""
                  }`}
                >
                  {activeTab === "history" && (
                    <TransactionHistory key={tabClickKey} />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddMoneyModal
        isOpen={showModal}
        onRequestClose={() => setShowModal(false)}
        cardBalance={cardBalance}
      />
    </div>
  );
};

export default CardManagement;
